import { Card, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CardSkeleton } from './CardSkeleton';
import { SHARED_CARD_STYLES } from '../constants';
import { SharedCardHeader } from './SharedCardHeader';

type MetricData = {
  value: number;
  description: string;
};

type MetricCardProps = {
  title: string;
  tooltipText: string;
  topMetric: MetricData;
  bottomMetric: MetricData;
  showViewButton?: boolean;
  onViewClick?: () => void;
  linkTo?: string;
  disabled?: boolean;
  isLoading?: boolean;
};

export const MetricCard = ({
  title,
  tooltipText,
  topMetric,
  bottomMetric,
  showViewButton = true,
  onViewClick,
  linkTo,
  disabled = false,
  isLoading = false,
}: MetricCardProps) => {
  const navigate = useNavigate();

  const handleViewClick = () => {
    if (onViewClick) {
      onViewClick();
    } else if (linkTo) {
      navigate(linkTo);
    }
  };

  const shouldShowViewButton = Boolean(
    showViewButton && (onViewClick || linkTo) && !disabled,
  );

  return (
    <Card
      className={SHARED_CARD_STYLES.className}
      headStyle={SHARED_CARD_STYLES.headStyle}
      bodyStyle={{
        ...SHARED_CARD_STYLES.bodyStyle,
      }}
      title={
        <SharedCardHeader
          title={title}
          tooltipText={tooltipText}
          disabled={disabled}
          shouldShowViewButton={shouldShowViewButton}
          onViewClick={handleViewClick}
        />
      }
      bordered={false}
    >
      {disabled || isLoading ? (
        <CardSkeleton />
      ) : (
        <div className="grid grid-cols-[48px_1fr] gap-x-2 h-full items-center ">
          <div className="text-3xl font-bold row-start-1 row-end-2 flex items-center justify-end">
            {topMetric.value}
          </div>
          <div className="text-sm text-gray-500 row-start-1 row-end-2 flex items-center pl-2">
            {topMetric.description}
          </div>
          <div className="col-span-2 my-2">
            <Divider style={{ margin: '0' }} />
          </div>
          <div className="text-3xl font-bold row-start-3 row-end-4 flex items-center justify-end">
            {bottomMetric.value}
          </div>
          <div className="text-sm text-gray-500 row-start-3 row-end-4 flex items-center pl-2">
            {bottomMetric.description}
          </div>
        </div>
      )}
    </Card>
  );
};
